export const STRIPE_PUBLIC_KEY = 'pk_live_up8PewwPu9siURgsszT26w3E00G5eSfOqK';

/**
 * Stripe plan type
 */
export const PLAN_TYPE = {
    MONTHLY: 'monthly',
    ANNUAL: 'annual'
};
